const MESSAGES_TO_IGNORE = [
  // we not interested in user's network issues
  "Network Error",
  "XHR error GET",
  // we not interested when the user's session has expired
  "Request failed with status code 401",
  // discard some typical react issues
  "Using UNSAFE_componentWillReceiveProps in strict mode",
  // Ignore some log lines about LaunchDarkly we do not need to know about
  "LaunchDarkly client initialized",
  "Opening stream connection to",
  "Closing stream connection",
  "Error on stream connection",
  "received streaming update for all flags",
  "polling for feature flags at",
  "sending diagnostic event",
  `enqueueing "feature" event`,
  `enqueueing "identify" event`,
];

// LaunchDarkly logs "sending N events" on every analytics flush — noisy in
// console during local dev. Regex because N varies.
const REGEX_MESSAGES_TO_IGNORE = [/sending \d+ events/i];

function ignoreMessage(message: unknown) {
  const stringMessage = String(message);
  const lower = stringMessage.toLowerCase();

  if (MESSAGES_TO_IGNORE.some((m) => lower.includes(m.toLowerCase()))) {
    return true;
  }

  return REGEX_MESSAGES_TO_IGNORE.some((pattern) => pattern.test(stringMessage));
}

export default ignoreMessage;
